import { CatAccordion } from '@blocks-react/components/Accordion';
import { FC, PropsWithChildren } from 'react';

export const SystemAndComponentAccordion: FC<PropsWithChildren> = ({
  children
}) => {
  return <CatAccordion singlePanelOnly>{children}</CatAccordion>;
};
